/** @jsx jsx */
import { jsx } from '@emotion/react';

import { useNavigate } from 'js/lib/useRouter';

import { Dialog } from '@coursera/cds-core';

import S12nExperiments from 'bundles/epic/clients/s12n';
import NotificationInfo from 'bundles/s12n-common/components/s12n-versioning-v2/NotificationInfo';
import UpdateInfo from 'bundles/s12n-common/components/s12n-versioning-v2/UpdateInfo';
import useFetchS12nVersioningInfo from 'bundles/s12n-common/components/s12n-versioning-v2/useFetchS12nVersioningInfo';

import _t from 'i18n!nls/program-home';

const S12nVersioningModal = () => {
  const { dismiss, defer, update, modalState, s12nUpdateInfo, confirmDefer } = useFetchS12nVersioningInfo();
  const navigateTo = useNavigate();

  if (modalState === 'hidden') return null;

  return (
    <Dialog width="large" aria-describedby="dialog-content" open variant="transactional">
      {modalState === 'update_info' && (
        <UpdateInfo update={update} confirmDefer={confirmDefer} s12nUpdateInfo={s12nUpdateInfo} />
      )}
      {modalState !== 'update_info' && (
        <NotificationInfo
          state={modalState}
          update={update}
          s12nUpdateInfo={s12nUpdateInfo}
          continueLearning={() => {
            dismiss();
            if (modalState === 'defer_modal') {
              defer();
            }
            navigateTo(`${s12nUpdateInfo.nextActiveItemUrl}`);
          }}
        />
      )}
    </Dialog>
  );
};

const isS12nVersioningV2Enabled = () => {
  return S12nExperiments.get('s12nVersioningM3');
};

export { isS12nVersioningV2Enabled };
export default S12nVersioningModal;
